import {jQuery as $, lodash as _} from 'lib/shim';
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from 'defines';




const SELECTOR = '.organism-teaserslider-four-columns';



class OrganismTeaserSlider4Columns {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$breakoutWrapper = this._$element.find('.breakout-wrapper');
			this._$teaserGroupWrapper = this._$breakoutWrapper.find('.teaser-group-wrapper').first();
			this._$navigationButtonsHolder = this._$breakoutWrapper.find('.navigation-buttons-holder').first();
			this._$prevButton = this._$navigationButtonsHolder.find('.prev-button').first();
			this._$nextButton = this._$navigationButtonsHolder.find('.next-button').first();
			this._$teaserBackgroundHolder = this._$breakoutWrapper.find('.teaser-background-holder').first();
			this._$sliderContent = this._$teaserGroupWrapper.find('.slider-content').first();
			this._$teaser = this._$teaserGroupWrapper.find('.molecule-teaser-list-item').first();
			this._$teaserImage = this._$teaser.find('.image-holder').first();
			this._$teaserContent = this._$teaser.find('.content-holder').first();


			this._prime();
		}

		return $element;
	}



	_prime() {
		let _$slider = this._$sliderContent
		.on('init', () => {
			this._setBackgroundPosition();
			this._$element.removeClass('cloaked');
		})
		.slick({
			infinite: false,
			appendDots: this._$teaserBackgroundHolder,
			dots: true,
			arrows: false,
			prevArrow: this._$prevButton,
			nextArrow: this._$nextButton,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: BREAKPOINT_TABLET - 1,
					settings: {
						arrows: false,
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: BREAKPOINT_DESKTOP + 1,
					settings: {
						arrows: true,
						slidesToShow: 4,
						slidesToScroll: 4
					}
				}
			]
		});

		this._app.registerResizeCallback('teaserslider-list-background-'+this._id, () => {
			_$slider.slick('refresh');
			this._setBackgroundPosition();
		});
	}



	_setBackgroundPosition() {
		if (this._$teaserImage.length > 0) {
			let imageHeight = this._$teaserImage.outerHeight(),
				backgroundBottomPosition = (imageHeight + 50) - 200; // 50px is the stick out value and 200px is the background-gradient height

			this._$teaserBackgroundHolder.css('top', backgroundBottomPosition);
		} else {
			this._$element.addClass('without-img');
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismTeaserSlider4Columns(app, $this));
	});

	return $elements;
}
